import { render, staticRenderFns } from "./InlineSplitTransaction.vue?vue&type=template&id=34898fdf&lang=pug&"
import script from "./InlineSplitTransaction.vue?vue&type=script&lang=js&"
export * from "./InlineSplitTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports